import type { PlayerId } from "../../core";
import type { ChessClock } from "../../app/clock";

/** Format remaining milliseconds the way a chess clock does. */
function formatTime(ms: number): string {
  const clamped = Math.max(0, ms);
  const totalSeconds = clamped / 1000;
  // Under 20 seconds, switch to seconds.tenths so the final scramble is legible.
  if (clamped < 20_000) {
    return totalSeconds.toFixed(1);
  }
  const whole = Math.ceil(totalSeconds);
  const minutes = Math.floor(whole / 60);
  const seconds = whole % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}

export function ClockReadout(props: { clock: ChessClock; owner: PlayerId }) {
  const ms = () => props.clock.remaining(props.owner);
  const running = () => props.clock.running(props.owner);
  const flagged = () => ms() <= 0;

  return (
    <span
      class="clock"
      classList={{
        running: running(),
        low: !flagged() && ms() < 30_000,
        critical: !flagged() && ms() < 10_000,
        flagged: flagged(),
      }}
      title="Time remaining"
    >
      {formatTime(ms())}
    </span>
  );
}
